document.addEventListener("DOMContentLoaded", function () {
    loadMenuButtons();
    createPopupContainer();
    loadJobAccordion();
    loadBookATableButton();
    loadGiftCardsButton();
    loadHomeSlideshow();
    loadToggleButtons();
    fixSubifyTabRoles();
    loadImageEmbedToggles();
    loadImageCardsLightbox();
});

let currentMenuId = "";

function loadMenuButtons() {
    const menuButtons = document.querySelectorAll('a[href^="/pages/"]');
    const filteredButtons = Array.from(menuButtons).filter(
        (button) =>
            button.textContent == "View Menu" ||
            button.textContent == "View Menus",
    );
    let allButtons = filteredButtons;
    const mapAddresses = document.querySelector(".map-addresses");
    if (mapAddresses) {
        const menuButtonsInnerPages = document.querySelectorAll(
            "a.section-image-with-text-button.btn-outline",
        );
        if (menuButtonsInnerPages.length > 0) {
            menuButtonsInnerPages.forEach((menuButtonsInnerPagesItem) => {
                allButtons = allButtons.concat([menuButtonsInnerPagesItem]);
            });
        }
    }

    // De-duplicate: a button can match both the text filter and the
    // .map-addresses class query. Processing it twice blanks its href on the
    // first pass, so the second pass would store an empty targetPage.
    const uniqueButtons = [...new Set(allButtons)];

    uniqueButtons.forEach((button) => {
        if (button.dataset.menuAction) return;
        const href = button.getAttribute("href");
        if (href && new URL(href, window.location.origin).pathname === "/pages/menus") return;
        button.setAttribute("href", "");
        button.dataset.targetPage = href;
        button.addEventListener("click", (event) => {
            event.preventDefault();
            const targetPage = button.dataset.targetPage;
            const url = `/pages/menus`;
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set("menu", targetPage);
            window.history.pushState({}, "", currentUrl);
            fetchAndShowPopupContent(url);
        });
    });

    document.querySelectorAll("a.block-button_wine_menu").forEach((button) => {
        if (!/\.pdf$/i.test(new URL(button.href, window.location.origin).pathname)) return;
        button.addEventListener("click", (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            fetchAndShowPopupContent("/pages/menus", {
                url: button.href,
                label: button.textContent.trim(),
            });
        });
    });
}

function createPopupContainer() {
    const popupContainer = document.createElement("div");
    popupContainer.id = "popupContainer";
    popupContainer.style.position = "fixed";
    popupContainer.style.top = "0";
    popupContainer.style.left = "0";
    popupContainer.style.width = "100%";
    popupContainer.style.height = "100%";
    popupContainer.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    popupContainer.style.display = "flex";
    popupContainer.style.justifyContent = "center";
    popupContainer.style.alignItems = "center";
    popupContainer.style.zIndex = "1000";
    popupContainer.style.overflow = "none";
    popupContainer.style.transition = "all 0.3s ease-in-out";
    popupContainer.style.opacity = "0";
    popupContainer.style.pointerEvents = "none";
    popupContainer.setAttribute("aria-hidden", "true");

    const contentWrapper = document.createElement("div");
    contentWrapper.id = "popupContent";
    contentWrapper.style.width = "100%";
    contentWrapper.style.height = "100%";
    contentWrapper.style.backgroundColor = "#fff";
    contentWrapper.style.overflow = "none";
    contentWrapper.style.padding = "20px";

    popupContainer.appendChild(contentWrapper);

    document.body.appendChild(popupContainer);
}

async function fetchAndShowPopupContent(menuUrl, requestedPdf) {
    currentMenuId = menuUrl; // Update currentMenuId with the new menu ID

    try {
        // Start both fetch operations in parallel
        const menuResponse = await fetch(menuUrl === "/pages/menus" ? "/pages/menus?view=ecom-menu-container" : menuUrl);

        // Check if the fetch operations were successful
        if (!menuResponse.ok) {
            throw new Error("Failed to fetch specific menu content");
        }

        // Convert both responses to text in parallel
        const menuHtml = await menuResponse.text();

        const popupContainer = document.getElementById("popupContainer");
        const contentWrapper = document.getElementById("popupContent");

        // Insert the received HTML for the main menu container
        contentWrapper.innerHTML = menuHtml;

        if (requestedPdf) {
            const pdfButton = document.createElement("a");
            pdfButton.className = "menus-pdf-button load-pdf-button menu-section-link";
            pdfButton.href = "#";
            pdfButton.dataset.pdfUrl = requestedPdf.url;
            pdfButton.textContent = requestedPdf.label;
            contentWrapper.querySelector("#menu-pdfs-buttons").prepend(pdfButton);
        }

        // const menuContainer = document.getElementById("menu-container");
        // // Insert the received HTML for the specific menu content
        // menuContainer.innerHTML = menuHtml;
        // menuContainer.style.overflowY = "auto";
        // menuContainer.style.overflowX = "hidden";
        // menuContainer.style.padding = "0 18px";
        // menuContainer.style.maxHeight = "calc(100vh - 80px)";
        // menuContainer.style.transition = "all 0.3s ease-in-out";

        const closeButton = document.getElementById("close-menu-popup");
        closeButton.addEventListener("click", () => {
            popupContainer.style.opacity = "0";
            popupContainer.style.pointerEvents = "none";
            popupContainer.setAttribute("aria-hidden", "true");

            document.body.style.overflowY = "auto";
            document.documentElement.style.overflowY = "auto";
        });

        // Show the popup and adjust the document's overflow to prevent scrolling
        popupContainer.style.opacity = "1";
        popupContainer.style.pointerEvents = "auto";
        popupContainer.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflowY = "hidden";

        loadPdfScripts(requestedPdf?.url);

        // loadSidebarButtons();
        // loadInsideMenuSidebarButtons(menuId);
    } catch (error) {
        console.error("Error loading the content:", error);
        if (requestedPdf) window.location.assign(requestedPdf.url);
    }
}

function loadSidebarButtons() {
    const buttons = document.querySelectorAll('a[id^="menu-id-"]');
    buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent the default anchor click behavior
            const menuId = button.id.replace("menu-id-", ""); // Extract menuId from the button's ID
            updateMenuContent(menuId); // Call the function to update the menu content with the extracted ID
        });
    });
}

function updateMenuContent(menuId) {
    // Check if the current menu ID is the same as the one requested
    if (currentMenuId === menuId) {
        return; // Exit the function if the current menu is already displayed
    }
    currentMenuId = menuId; // Update currentMenuId with the new menu ID

    const newContentUrl = `/pages/menu-${menuId}`;
    const menuContainer = document.getElementById("menu-container");

    if (!menuContainer) {
        console.error("Menu container element not found.");
        return;
    }

    // Start by hiding the menuContainer
    menuContainer.style.opacity = "0";

    const menuLinks = document.querySelectorAll(".menu-section-link");

    menuLinks.forEach((link) => {
        link.parentNode.removeChild(link);
    });

    fetch(newContentUrl)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Failed to fetch new menu content");
            }
            return response.text();
        })
        .then((html) => {
            // Update the HTML content
            menuContainer.innerHTML = html;
            menuContainer.style.overflowY = "auto"; // Ensure scrolling is enabled if content is longer than the container
            loadInsideMenuSidebarButtons(menuId);

            // Wait for the fade-out effect to complete before changing the content
            setTimeout(() => {
                menuContainer.style.opacity = "1"; // Fade in the menu container after the content is loaded
            }, 300); // Adjust time as needed to match the fade-out duration
        })
        .catch((error) => {
            console.error("Error loading the new menu content:", error);
            menuContainer.style.opacity = "1"; // Ensure the container is visible even if there's an error
        });
}

function loadInsideMenuSidebarButtons(menuId) {
    const menuSections = document.querySelectorAll(".menu-section");
    if (menuSections.length > 0) {
        const menuSectionsReverse = Array.from(menuSections).reverse();
        menuSectionsReverse.forEach((menuSection, index) => {
            const menuSectionName = menuSection.getAttribute("name");
            const menuSectionId = menuSection.id;

            const menuLink = document.querySelector(`a#menu-id-${menuId}`);
            const parent = menuLink.parentElement.parentElement;

            const cloneButton = parent.cloneNode(true);
            const cloneButtonLink = cloneButton.querySelector(
                `a#menu-id-${menuId}`,
            );
            cloneButtonLink.removeAttribute("id");

            cloneButtonLink.classList.add("menu-section-link");

            if (index != menuSectionsReverse.length - 1) {
                cloneButtonLink.style.marginTop = "0";
            } else {
                cloneButtonLink.style.marginTop = "15px";
            }

            if (index == 0) {
                cloneButtonLink.classList.add("menu-section-link-last");
            }

            const cloneButtonText = cloneButtonLink.querySelector(
                ".ecom__element--button-icon-text",
            );
            cloneButtonText.textContent = menuSectionName;

            // Agregar controlador de eventos de clic al botón clonado
            cloneButtonLink.addEventListener("click", (event) => {
                event.preventDefault();
                menuSection.scrollIntoView({ behavior: "smooth" });
            });

            if (parent.nextSibling) {
                parent.parentNode.insertBefore(cloneButton, parent.nextSibling);
            } else {
                parent.parentNode.appendChild(cloneButton);
            }
        });
    }
}

function loadJobAccordion() {
    const jobAccordionItems = document.querySelectorAll(".job-accordion-item");
    if (jobAccordionItems.length > 0) {
        jobAccordionItems.forEach((item) => {
            const title = item.querySelector(".job-accordion-title");
            const content = item.querySelector(".job-accordion-content");

            // Set initial aria-hidden state based on opened class
            if (content) {
                content.setAttribute(
                    "aria-hidden",
                    item.classList.contains("opened") ? "false" : "true",
                );
            }

            title.addEventListener("click", () => {
                item.classList.toggle("opened");
                const isOpen = item.classList.contains("opened");
                title.setAttribute("aria-expanded", isOpen ? "true" : "false");
                if (content) {
                    content.setAttribute(
                        "aria-hidden",
                        isOpen ? "false" : "true",
                    );
                }
            });
        });
    }
}

function getPopupContent(type) {
    if (type == "reservations") {
        return {
            title: "RESERVATIONS",
            subtitle: "Select a restaurant location",
            buttons: [
                {
                    label: "Bird Road",
                    href: "https://www.opentable.com/restref/client/?rid=4721&restref=4721&lang=en-US&color=2&r3uid=cfe&dark=true&ot_source=Restaurant%20website&corrid=e9734637-bb16-441f-a812-5a85280278e1",
                },
                {
                    label: "Hialeah",
                    href: "https://www.opentable.com/restref/client/?rid=16924&restref=16924&lang=en-US&color=2&r3uid=cfe&dark=true&ot_source=Restaurant%20website&corrid=0e3e1e20-26f1-4f09-a39c-75805eda102b",
                },
                {
                    label: "Coral Gables",
                    href: "https://www.opentable.com/restref/client/?rid=4722&restref=4722&lang=en-US&color=2&r3uid=cfe&dark=true&ot_source=Restaurant%20website&corrid=9a7d3a6d-b429-4ef9-9a68-b82715e8f618",
                },
            ],
        };
    } else if (type == "giftcards") {
        return {
            title: "GIFT CARDS",
            subtitle: "Choose a location to purchase gift cards",
            buttons: [
                {
                    label: "Aventura",
                    href: "https://www.toasttab.com/grazianos-market-aventura/giftcards",
                },
                {
                    label: "Bird Road",
                    href: "https://www.toasttab.com/grazianos-market-bird-road-3922/giftcards",
                },
                {
                    label: "Coral Gables",
                    href: "https://www.toasttab.com/grazianos-market-coral-gables-2301/giftcards",
                },
                {
                    label: "Doral",
                    href: "https://www.toasttab.com/grazianos-market-doral-11421/giftcards",
                },
                {
                    label: "Weston",
                    href: "https://www.toasttab.com/grazianos-market-weston-1721/giftcards",
                },
                {
                    label: "Gables Lifetime",
                    href: "https://www.toasttab.com/grazianos-market-south-gables-229-south-dixie-hwy/giftcards",
                },
            ],
        };
    }
}

function createPopup(type) {
    // Create the lens effect container
    const lensContainer = document.createElement("div");
    lensContainer.id = "lens";
    lensContainer.style.position = "fixed";
    lensContainer.style.top = "0";
    lensContainer.style.left = "0";
    lensContainer.style.width = "100%";
    lensContainer.style.height = "100%";
    lensContainer.style.background = "rgba(0, 0, 0, 0.6)";
    lensContainer.style.display = "flex";
    lensContainer.style.justifyContent = "center";
    lensContainer.style.alignItems = "center";
    lensContainer.style.zIndex = "1000";
    lensContainer.style.opacity = "0";
    lensContainer.style.transition = "opacity 0.5s";
    lensContainer.style.pointerEvents = "none"; // Prevent clicks when hidden
    lensContainer.style.overflow = "hidden"; // Remove overflow
    lensContainer.setAttribute("aria-hidden", "true");

    // Create the popup container inside the lens
    const popup = document.createElement("div");
    popup.classList.add("reservations-popup");
    popup.style.position = "absolute";
    popup.style.top = "50%";
    popup.style.left = "50%";
    popup.style.transform = "translate(-50%, -50%)";
    popup.style.backgroundColor = "#000"; // Black background
    popup.style.padding = "25px";
    popup.style.zIndex = "1002";

    const popupContent = getPopupContent(type);

    const title = document.createElement("h2");
    title.innerText = popupContent.title;

    const closeIcon = document.createElement("button");
    closeIcon.classList.add("close-icon");
    closeIcon.setAttribute("aria-label", "Close");
    closeIcon.style.background = "none";
    closeIcon.style.border = "none";
    closeIcon.style.cursor = "pointer";
    closeIcon.style.padding = "0";
    closeIcon.innerHTML =
        '<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.21313 1.37549L27.802 27.9643" stroke="white" stroke-width="2"/><path d="M27.8022 1.37549L14.5078 14.6699L1.21341 27.9643" stroke="white" stroke-width="2"/></svg>';

    const subtitle = document.createElement("p");
    subtitle.innerText = popupContent.subtitle;

    popup.appendChild(title);
    popup.appendChild(closeIcon);
    popup.appendChild(subtitle);

    // Create the buttons container
    const buttonsContainer = document.createElement("div");
    buttonsContainer.classList.add("button-popup-container");

    popupContent.buttons.forEach((buttonItem) => {
        const button = document.createElement("a");
        button.innerText = buttonItem.label;
        button.classList.add("button-popup");
        button.href = buttonItem.href;

        buttonsContainer.appendChild(button);
    });

    // Append the buttons container to the popup
    popup.appendChild(buttonsContainer);

    // Append the lens and popup to the lens container
    lensContainer.appendChild(popup);

    // Append the lens container to the body
    document.body.appendChild(lensContainer);

    const closePopup = () => {
        lensContainer.style.opacity = "0";
        lensContainer.style.pointerEvents = "none";
        lensContainer.setAttribute("aria-hidden", "true");
        document.documentElement.style.overflow = "auto";
        document.body.style.overflow = "auto";
    };

    // Close the popup when clicking outside of the lens
    lensContainer.addEventListener("click", (event) => {
        if (event.target === lensContainer) {
            closePopup();
        }
    });
    closeIcon.addEventListener("click", (event) => {
        closePopup();
    });

    return lensContainer;
}

function loadBookATableButton() {
    const bookTableButtons = document.querySelectorAll(".book-a-table-button");
    const lensContainer = createPopup("reservations");

    if (bookTableButtons.length > 0) {
        bookTableButtons.forEach((item) => {
            item.addEventListener("click", () => {
                lensContainer.style.opacity = "1";
                lensContainer.style.pointerEvents = "auto";
                lensContainer.setAttribute("aria-hidden", "false");
                document.documentElement.style.overflow = "hidden";
                document.body.style.overflow = "hidden";
            });
        });
    }
}

function loadGiftCardsButton() {
    const giftCardButtons = document.querySelectorAll(".gift-cards-button");
    const lensContainer = createPopup("giftcards");

    if (giftCardButtons.length > 0) {
        giftCardButtons.forEach((item) => {
            item.addEventListener("click", () => {
                lensContainer.style.opacity = "1";
                lensContainer.style.pointerEvents = "auto";
                lensContainer.setAttribute("aria-hidden", "false");
                document.documentElement.style.overflow = "hidden";
                document.body.style.overflow = "hidden";
            });
        });
    }
}

function loadHomeSlideshow() {
    const slides = document.querySelectorAll(".home-slide-item");
    const indicators = document.querySelectorAll(".indicator");

    if (slides.length === 0) {
        return;
    }

    let currentSlide = 0;
    const slideInterval = 5000; // Slide change interval in milliseconds
    let intervalId;

    // Function to show a specific slide
    function showSlide(index) {
        // Remove active class from all slides and indicators
        slides.forEach((slide) => slide.classList.remove("active"));
        indicators.forEach((indicator) => indicator.classList.remove("active"));

        // Add active class to the selected slide and indicator
        slides[index].classList.add("active");

        indicators.forEach((indicator) => {
            if (parseInt(indicator.dataset.slide) == index) {
                indicator.classList.add("active");
            }
        });

        // Update currentSlide
        currentSlide = index;
    }

    // Function to show the next slide
    function nextSlide() {
        let nextIndex = (currentSlide + 1) % slides.length;
        showSlide(nextIndex);
    }

    // Start the slideshow interval
    function startSlideshow() {
        intervalId = setInterval(nextSlide, slideInterval);
    }

    // Stop the slideshow interval
    function stopSlideshow() {
        clearInterval(intervalId);
    }

    // Initialize the first slide and indicator
    showSlide(currentSlide);

    // Start the slideshow
    startSlideshow();

    // Add click event listeners to indicators
    indicators.forEach((indicator) => {
        indicator.addEventListener("click", function () {
            let slideIndex = parseInt(this.getAttribute("data-slide"));
            showSlide(slideIndex);
            // Restart the slideshow interval
            stopSlideshow();
            startSlideshow();
        });
    });
}

function changeToggleState(toggleType, clickedButton) {
    const toggleButtons = document.querySelectorAll(".toggle-btn");
    const toggleContents = document.querySelectorAll(".toggle-content");
    const toggleImages = document.querySelectorAll(".toggle-image");
    const toggleSlider = document.querySelector(".toggle-slider"); // Slider Element

    // Remove active class from all buttons and update aria-pressed
    toggleButtons.forEach((btn) => {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
    });

    // Add active class to the clicked button and update aria-pressed
    if (clickedButton) {
        clickedButton.classList.add("active");
        clickedButton.setAttribute("aria-pressed", "true");
    }

    // Move the slider
    if (toggleSlider) {
        if (toggleType === "restaurant") {
            toggleSlider.style.left = "0%";
        } else if (toggleType === "mercado") {
            toggleSlider.style.left = "50%";
        }
    }

    // Hide all content sections and remove active class
    toggleContents.forEach((content) => content.classList.remove("active"));

    // Show the selected content
    const selectedContent = document.querySelector(
        `.toggle-content.${toggleType}-content`,
    );
    if (selectedContent) {
        selectedContent.classList.add("active");
    }

    // Hide all images and remove active class
    toggleImages.forEach((img) => img.classList.remove("active"));

    // Show the selected image
    const selectedImage = document.querySelector(
        `.toggle-image.${toggleType}-image`,
    );
    if (selectedImage) {
        selectedImage.classList.add("active");
    }
}

function loadToggleButtons() {
    const toggleButtons = document.querySelectorAll(".toggle-btn");
    const toggleSlider = document.querySelector(".toggle-slider"); // Slider Element

    toggleButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const toggleType = this.getAttribute("data-toggle");
            changeToggleState(toggleType, this);
        });
    });

    // Initialize slider position based on the default active button
    const activeButton = document.querySelector(".toggle-btn.active");
    if (activeButton && toggleSlider) {
        const toggleType = activeButton.getAttribute("data-toggle");
        if (toggleType === "restaurant") {
            toggleSlider.style.left = "0%";
        } else if (toggleType === "mercado") {
            toggleSlider.style.left = "50%";
        }
    }

    // Check URL hash on load
    if (window.location.hash === "#mercado") {
        // Find the button corresponding to "mercado"
        const mercadoButton = document.querySelector(
            '.toggle-btn[data-toggle="mercado"]',
        );
        changeToggleState("mercado", mercadoButton);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    // Function to parse URL parameters
    function getQueryParams() {
        const params = {};
        const queryString = window.location.search.substring(1);
        const pairs = queryString.split("&");
        for (let pair of pairs) {
            if (pair) {
                const [key, value] = pair.split("=");
                // Decode and handle array-like keys
                const decodedKey = decodeURIComponent(key.replace(/\[\]/, ""));
                const decodedValue = decodeURIComponent(value);
                if (decodedKey in params) {
                    // If key exists, convert to array or add to existing array
                    if (Array.isArray(params[decodedKey])) {
                        params[decodedKey].push(decodedValue);
                    } else {
                        params[decodedKey] = [params[decodedKey], decodedValue];
                    }
                } else {
                    params[decodedKey] = decodedValue;
                }
            }
        }
        return params;
    }

    // Function to display messages based on parameters
    function displayMessageBasedOnURL() {
        const successMessage = document.querySelector(
            ".newsletter-form__message--success",
        );
        if (!successMessage) {
            return;
        }
        const params = getQueryParams();

        // Example condition: form_type=customer and contact_tags contains 'newsletter'
        if (
            params.form_type === "customer" &&
            params["contact[tags]"] == "newsletter"
        ) {
            successMessage.style.display = "block";

            // Scroll to the success message for better UX
            successMessage.scrollIntoView({ behavior: "smooth" });

            // Optionally, focus on the message for accessibility
            successMessage.focus();
        }
    }

    // Call the function to display messages
    displayMessageBasedOnURL();
});

let menuPdfLibraryPromise;

function ensureMenuPdfLibrary() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (!menuPdfLibraryPromise) {
        menuPdfLibraryPromise = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.min.js";
            script.async = true;
            const timeout = window.setTimeout(() => fail(), 15000);
            function fail() {
                window.clearTimeout(timeout);
                script.remove();
                reject(new Error("The PDF viewer could not load."));
            }
            script.onerror = fail;
            script.onload = () => {
                window.clearTimeout(timeout);
                if (window.pdfjsLib) resolve(window.pdfjsLib);
                else fail();
            };
            document.head.appendChild(script);
        }).catch(error => {
            menuPdfLibraryPromise = null;
            throw error;
        });
    }
    return menuPdfLibraryPromise;
}

function loadPdfScripts(initialPdfUrl) {
    // Mobile menu drawer toggle
    const menuToggle = document.getElementById("menu-pdfs-toggle");
    const menuButtons = document.getElementById("menu-pdfs-buttons");
    if (menuToggle && menuButtons) {
        const setDrawer = (open) => {
            menuButtons.classList.toggle("open", open);
            menuToggle.classList.toggle("open", open);
            menuToggle.setAttribute("aria-expanded", String(open));
        };

        menuToggle.addEventListener("click", function () {
            setDrawer(!menuButtons.classList.contains("open"));
        });

        // Close the drawer once a PDF item is selected so the PDF is visible
        menuButtons.addEventListener("click", function (event) {
            if (event.target.closest(".load-pdf-button")) {
                setDrawer(false);
            }
        });
    }

    // Select all buttons with the class 'load-pdf-button'
    const loadButtons = document.querySelectorAll(".load-pdf-button");
    const pdfContainer = document.getElementById("pdf-container");

    if (!pdfContainer) return;
    let selection = 0;
    let activeTask;

    const cancelCurrentPdf = () => {
        selection += 1;
        if (activeTask) {
            activeTask.destroy().catch(() => {});
            activeTask = null;
        }
    };
    document.getElementById("close-menu-popup")?.addEventListener("click", cancelCurrentPdf);

    loadButtons.forEach(button => {
        const pdfUrl = button.dataset.pdfUrl;
        if (!pdfUrl) return;
        button.href = pdfUrl;
        button.addEventListener("click", async event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            cancelCurrentPdf();
            const currentSelection = selection;
            const isCurrent = () => currentSelection === selection && pdfContainer.isConnected;
            const original = document.createElement("a");
            original.href = pdfUrl;
            original.textContent = pdfContainer.dataset.originalLabel;
            original.className = "menu-pdf-original";
            const status = document.createElement("p");
            status.setAttribute("role", "status");
            status.textContent = pdfContainer.dataset.loadingLabel;
            pdfContainer.replaceChildren(original, status);
            try {
                const library = await ensureMenuPdfLibrary();
                if (!isCurrent()) return;
                library.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js";
                activeTask = library.getDocument(pdfUrl);
                const pdf = await activeTask.promise;
                if (!isCurrent()) return;
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    const page = await pdf.getPage(pageNum);
                    if (!isCurrent()) return;
                    const viewport = page.getViewport({ scale: 3 });
                    const canvas = document.createElement("canvas");
                    canvas.classList.add("pdf-page");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    canvas.setAttribute("aria-hidden", "true");
                    pdfContainer.appendChild(canvas);
                    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
                    if (!isCurrent()) return;
                }
                status.remove();
            } catch (error) {
                if (!isCurrent()) return;
                status.textContent = pdfContainer.dataset.errorLabel;
                console.error("Error loading PDF:", error);
            }
        });
    });

    function getQueryParams() {
        const params = {};
        const queryString = window.location.search.substring(1);
        const regex = /([^&=]+)=?([^&]*)/g;
        let match;

        while ((match = regex.exec(queryString))) {
            const key = decodeURIComponent(match[1].replace(/\+/g, " "));
            const value = decodeURIComponent(match[2].replace(/\+/g, " "));
            params[key] = value;
        }

        return params;
    }

    // Handle opening and closing of collapsible sections
    const collapseButtons = document.querySelectorAll(
        ".menus-pdf-collapse-button",
    );

    collapseButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            const targetId = this.getAttribute("data-collapse-target");
            const collapsible = document.querySelector(
                `.menus-pdfs-collapsable[data-collapse-id="${targetId}"]`,
            );

            if (collapsible) {
                const isActive = collapsible.classList.contains("active");

                // Toggle current section
                collapsible.classList.toggle("active");
                this.classList.toggle("active"); // Optional: toggle active class on button

                // Optionally, close other sections if you want only one open at a time
                if (!isActive) {
                    const pdfButtons = collapsible.children;
                    if (pdfButtons.length > 0) {
                        pdfButtons[0].click();
                    }
                    // Only close others if opening a new section
                    collapseButtons.forEach((btn) => {
                        if (btn !== button) {
                            const otherTargetId = btn.getAttribute(
                                "data-collapse-target",
                            );
                            const otherCollapsible = document.querySelector(
                                `.menus-pdfs-collapsable[data-collapse-id="${otherTargetId}"]`,
                            );
                            if (
                                otherCollapsible &&
                                otherCollapsible.classList.contains("active")
                            ) {
                                otherCollapsible.classList.remove("active");
                                btn.classList.remove("active"); // Optional: remove active class from other buttons
                            }
                        }
                    });
                }
            }
        });
    });

    if (initialPdfUrl) {
        const initialButton = Array.from(loadButtons).find(
            (button) => button.dataset.pdfUrl === initialPdfUrl,
        );
        if (initialButton) initialButton.click();
        return;
    }

    const queryParams = getQueryParams();
    if (queryParams.menu) {
        const menuUrl = queryParams.menu.trim().replace("%2F", "/");
        if (menuUrl) {
            // Find the corresponding button
            const targetButton = Array.from(collapseButtons).find((btn) => {
                const targetId = btn.getAttribute("data-collapse-target");
                return targetId.toLowerCase() === menuUrl.toLowerCase();
            });

            if (targetButton) {
                // Simulate a click to expand
                targetButton.click();
            } else {
                const openByDefault =
                    document.querySelector(".open-by-default");
                if (openByDefault) {
                    openByDefault.click();
                }
            }
        }
    }
}

function fixSubifyTabRoles() {
    const observer = new MutationObserver(function () {
        const subifyRoot = document.querySelector(".subify-root");
        if (!subifyRoot) return;

        const tabList = subifyRoot.querySelector(
            "[class*='tab-list'], [class*='tablist'], [class*='tabs']",
        );
        if (tabList && !tabList.getAttribute("role")) {
            tabList.setAttribute("role", "tablist");
            const tabs = tabList.querySelectorAll("[class*='tab']");
            tabs.forEach(function (tab) {
                if (!tab.getAttribute("role")) {
                    tab.setAttribute("role", "tab");
                }
            });
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

function loadImageEmbedToggles() {
    document.querySelectorAll(".image-embed-toggle").forEach((button) => {
        const container = button.closest(".has-embed");
        const frame = container.querySelector(".image-embed");
        const iframe = frame.querySelector("iframe");
        const label = button.querySelector(".image-embed-toggle__label");

        button.addEventListener("click", () => {
            const active = container.classList.toggle("is-embed-active");
            if (active && !iframe.getAttribute("src")) {
                iframe.setAttribute("src", iframe.dataset.src);
            }
            frame.hidden = !active;
            button.setAttribute("aria-pressed", String(active));
            label.textContent = active
                ? button.dataset.labelOn
                : button.dataset.labelOff;
        });
    });
}

function loadImageCardsLightbox() {
    if (!document.querySelector("a.image-card-lightbox")) return;
    if (typeof PhotoSwipeLightbox === "undefined" || typeof PhotoSwipe === "undefined") return;

    const lightbox = new PhotoSwipeLightbox({
        gallery: "main.main",
        children: "a.image-card-lightbox",
        pswpModule: PhotoSwipe,
    });

    lightbox.on("uiRegister", () => {
        lightbox.pswp.ui.registerElement({
            name: "custom-caption",
            order: 9,
            isButton: false,
            appendTo: "root",
            onInit: (element, pswp) => {
                pswp.on("change", () => {
                    const link = pswp.currSlide.data.element;
                    element.textContent = link ? link.dataset.caption || "" : "";
                });
            },
        });
    });

    lightbox.init();
}
